import React from "react";
import ServicePage from "@/components/ServicePage";
import { radiofrequenzaData } from "@/data/services";

export default function Radiofrequenza() {
    return <ServicePage data={radiofrequenzaData} />;
}
